import { adNotam } from '../../init';

adNotam.website.onenew = {
  init: function () {
    $('video').mediaelementplayer();
  }
};
